import React from 'react';
import PropTypes from 'prop-types';
import {createForm, formShape} from 'rc-form';
import {InputField, RichTextEditorField} from 'components/common/fields';
import {addFlashMessage} from 'actions/flash-message';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';


class QuizForm extends React.Component {
    static propTypes = {
        form: formShape,
        initialValues: PropTypes.object.isRequired,
    };

    static defaultProps = {
        initialValues: {},
    };

    rteOnChange(value, initialValue) {
        const {onChange} = this.props;
        if (value !== initialValue) {
            onChange();
        }
    }

    render() {
        const {initialValues, form, onChange} = this.props;

        return (
            <>
            <InputField
                name="name"
                label="Quiz Name"
                initialValue={initialValues['name']}
                rules={[
                    {required: true, message: 'Please enter the quiz name.'},
                ]}
                form={form}
                autoComplete="off"
                variant="outlined"
                onChange={onChange}
            />
            <RichTextEditorField
                name="start_message"
                label={<Typography variant={'h6'}>(Optional) Quiz start message</Typography>}
                initialValue={initialValues['startMessage']}
                form={form}
                onChange={currentVal => this.rteOnChange(currentVal, initialValues['startMessage'])}
            />
            <RichTextEditorField
                name="end_message"
                label={<Typography variant={'h6'}>(Optional) Quiz end message</Typography>}
                initialValue={initialValues['endMessage']}
                form={form}
                onChange={currentVal => this.rteOnChange(currentVal, initialValues['endMessage'])}
            />
        </>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizForm.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(createForm()(QuizForm)));
